import { useTranslation } from 'react-i18next';

import React, { PropsWithChildren } from 'react';

import { Text } from '@thinkific/chalk/react-components';
import { XCircle } from '@thinkific/chalk/react-icons';

import ActionButton from '../DocumentEditor/ActionButton';
import * as css from './ReplyingContext.css';

interface ReplyingContextProps extends PropsWithChildren {
  isEditing?: boolean;
  replyingTo?: string;
  closeReplyOnComment?: () => void;
}

const ReplyingContext = ({
  isEditing = false,
  replyingTo,
  closeReplyOnComment,
  children,
}: ReplyingContextProps) => {
  const { t } = useTranslation();

  if (!replyingTo) return <>{children}</>;
  return (
    <div className={css.replyBorderStyle}>
      <div className={css.replyTextContainer}>
        <div>
          <Text variant="label.xs">
            {isEditing
              ? t('components-richTextEditor-editing', 'Editing')
              : t('components-richTextEditor-reply_to_post', 'Replying to ')}
          </Text>
          <Text variant="body.xs">&nbsp;{replyingTo}</Text>
        </div>
        {!isEditing && (
          <ActionButton
            arialLabel={t('components-richTextEditor-cancel_reply', 'Cancel reply')}
            className={css.cancelReplyButton}
            disabled={false}
            icon={XCircle}
            isActive={false}
            onClick={closeReplyOnComment}
          />
        )}
      </div>
      {children}
    </div>
  );
};

ReplyingContext.displayName = 'ReplyingContext';

export default ReplyingContext;
